import type { components } from '@connected/api-client/api.generated';
import type { MediaFile, MediaFileId } from '@connected/api-client/database/schema';

import { createContext, use } from 'react';

export type ElectricalProjectFile = components['schemas']['ListElectricalProjectFileQueryResultFile'];
export type ElectricalProjectFileWithMedia = ElectricalProjectFile & {
    mediaFile?: MediaFile | null | undefined;
};

export type ElectricalProjectFileUploadValidationRequirements = components['schemas']['RetrieveFileUploadValidationRequirementsResponse'];

export type ElectricalProjectFileUploadResult = components['schemas']['UploadFileCommandResult'];

export type ElectricalProjectFilesContext = {
    files: ElectricalProjectFile[];
    generateMediaFileId: (electricalProjectFile: ElectricalProjectFile) => MediaFileId;
    getElectricalProjectFile: (electricalProjectFileId: string | null | undefined) => ElectricalProjectFile | null;
};

export const ElectricalProjectFilesContext = createContext<ElectricalProjectFilesContext | null>(null);

export function useElectricalProjectFiles() {
    const context = use(ElectricalProjectFilesContext);

    if (!context) {
        throw new Error('ElectricalProjectFilesContext not found');
    }

    return context;
}
